// @flow
import React from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { CopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { UserFeedback } from '@ta-interaktiv/react-user-feedback'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import { ShareButtons } from '@ta-interaktiv/react-share-buttons'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'

type Props = {
  articleId: string,
  publicationDate: number,
}

export function Footer({ articleId, publicationDate }: Props) {
  return (
    <footer className='ui vertical padded grey segment ta footer'>
      <div className='ui container'>
        <div className='ui text container user-feedback-container'>
          <UserFeedback
            theme='simple'
            starIcon='star'
            articleId='18446938'
            starColor='#007abf'
            fontColor='#fff'
            backgroundColor='#333'
            starAmount='5'
            title='Wie bewerten Sie diesen Beitrag?'
            questions={[
              'Wie gefällt Ihnen die Vollansicht-Bildstrecke?',
              'Wie gut ist die Bedienbarkeit?',
            ]}
          />
        </div>

        <div className='ui grid'>
          <div className='two column stackable row'>
            <div className='column'>
              <table className='ui small very basic definition infographic unstackable table'>
                <tbody>
                  <tr>
                    <td>Bildredaktion und Texte</td>
                    <td>Boris Müller</td>
                  </tr>
                  <tr>
                    <td>Programmierung</td>
                    <td>Mathias Lutz, Interaktiv-Team</td>
                  </tr>
                  <tr>
                    <td>Veröffentlicht</td>
                    <td>
                      <TimestampFormatter timestamp={publicationDate} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='column'>
              <FeedbackMessage className='inverted' />
            </div>
          </div>

          <div className='two column stackable row'>
            <div className='column'>
              <CopyrightNotice inverted />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
